/**
 * Copy editorial das páginas legais (hero / header).
 *
 * Não faz parte do texto jurídico. Títulos oficiais, versão e data
 * continuam em privacyPolicyContent / termsOfUseContent.
 */

export const LEGAL_PAGE_EXPERIENCE = Object.freeze({
  "Termos de Uso": Object.freeze({
    contextLabel: "Termos de Uso",
    kicker: "FIVI360 · Termos de Uso",
    description:
      "Condições para usar o site, o aplicativo e os recursos públicos da plataforma.",
  }),
  "Política de Privacidade": Object.freeze({
    contextLabel: "Política de Privacidade",
    kicker: "FIVI360 · Privacidade",
    description:
      "Como tratamos dados pessoais, cookies e as suas escolhas na plataforma.",
  }),
});

/**
 * @param {{ title?: string } | null | undefined} document
 * @returns {{
 *   contextLabel: string,
 *   kicker: string,
 *   description: string,
 * }}
 */
export function getLegalPageExperience(document) {
  const title = document?.title ?? "";
  const preset = LEGAL_PAGE_EXPERIENCE[title];

  if (preset) {
    return preset;
  }

  return {
    contextLabel: title,
    kicker: title ? `FIVI360 · ${title}` : "FIVI360",
    description: "",
  };
}
